import React, { useEffect } from 'react'
import {
  BrowserRouter as Router,
  Switch,
} from 'react-router-dom'
import {
  Dashboard,
  Profile,
  Login,
  Register,
  PrivacyPolicy,
  TermsCondition,
  HomepageQuickey,
  CreateApp,
  UpdateApp,
  SocialApp,
  OtpApp,
  Report,
  AppDetail,
  ContactUs,
  NotificationList,

  Templates,
  GroupContacts,
  Contacts,
  BroadcastReport,
  BroadcastSetting,
  NewTemplate,
  EditTemplate,
  NewContact,
  NewBroadcast,

  ContactUsList,
  TemplateSubmission
} from './pages'
import { Provider } from 'react-redux'
import store from './store/index'
import AuthRoute from './components/AuthRoute' 
import "./App.css";
import "./public/fonts/style.css";
import "./marginHelper.css";
import env from "./env"

const App = () => {
  const facebookAppId = env.REACT_APP_FACEBOOK_APP_ID; 
  useEffect(() => {
    window.fbAsyncInit = function() {
            window.FB.init({
                appId      : facebookAppId,
                cookie     : false,
                xfbml      : true,
                version    : 'v10.0',
            });        
        };

        (function(d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s); js.id = id;
        js.src = "https://connect.facebook.net/de_DE/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));
  }, [facebookAppId])

  return (
    <Provider store={store}>
        <Router>
        <Switch>
        <AuthRoute path="/" exact type="guest">
          <HomepageQuickey></HomepageQuickey>
        </AuthRoute>
        <AuthRoute path="/login" type="guest">
          <Login></Login>
        </AuthRoute>
        <AuthRoute path="/register" type="guest">
          <Register></Register>
        </AuthRoute>
        <AuthRoute path="/contactus" type="guest">
          <ContactUs></ContactUs>
        </AuthRoute>
        <AuthRoute path="/termscondition" type="guest">
          <TermsCondition></TermsCondition>
        </AuthRoute>
        <AuthRoute path="/privacypolicy" type="guest">
          <PrivacyPolicy></PrivacyPolicy>
        </AuthRoute>
        <AuthRoute path="/app/:id/socialLogin" type="private">
          <SocialApp></SocialApp>
        </AuthRoute>
        <AuthRoute path="/app/:id/otpLogin" type="private">
          <OtpApp></OtpApp>
        </AuthRoute>
        <AuthRoute path="/app/:id/report" type="private">
          <Report></Report>
        </AuthRoute>
        <AuthRoute path="/app/:id" type="private">
          <AppDetail></AppDetail>
        </AuthRoute>
        <AuthRoute path="/createApp" type="private">
          <CreateApp></CreateApp>
        </AuthRoute>
        <AuthRoute path="/updateApp/:id" type="private">
          <UpdateApp></UpdateApp>
        </AuthRoute>
        <AuthRoute path="/app" type="private">
          <Dashboard></Dashboard>
        </AuthRoute>
        <AuthRoute path="/profile" type="private">
          <Profile></Profile>
        </AuthRoute>
        <AuthRoute path="/notifications" type="private">
          <NotificationList></NotificationList>
        </AuthRoute>
        <AuthRoute path="/broadcast/template" type="private">
          <Templates></Templates>
        </AuthRoute>
        <AuthRoute path="/broadcast/group" type="private">
          <GroupContacts></GroupContacts>
        </AuthRoute>
        <AuthRoute path="/broadcast/contact" type="private">
          <Contacts></Contacts>
        </AuthRoute>
        <AuthRoute path="/broadcast/report" type="private">
          <BroadcastReport></BroadcastReport>
        </AuthRoute>
        <AuthRoute path="/broadcast/config" type="private">
          <BroadcastSetting></BroadcastSetting>
        </AuthRoute>
        <AuthRoute path="/broadcast/newTemplate" type="private">
          <NewTemplate></NewTemplate>
        </AuthRoute>
        <AuthRoute path="/broadcast/editTemplate/:templateId" type="private">
          <EditTemplate></EditTemplate>
        </AuthRoute>
        <AuthRoute path="/broadcast/newContact" type="private">
          <NewContact></NewContact>
        </AuthRoute>
        <AuthRoute path="/broadcast/newBroadcast" type="private">
          <NewBroadcast></NewBroadcast>
        </AuthRoute>
        <AuthRoute path="/admin/contactUs" type="private">
          <ContactUsList></ContactUsList>
        </AuthRoute>
        <AuthRoute path="/admin/templateSubmission" type="private">
          <TemplateSubmission></TemplateSubmission>
        </AuthRoute>
      </Switch>
    </Router>
    </Provider>
  );
}

export default App;